module.exports = __webpack_public_path__ + "static/forecast/weather/nightsnowshowers-a33cddafb199c73af7ea93dee5ae0462.svg";